import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import {
  LoadingController,
  ModalController,
  ToastController,
} from "@ionic/angular";
import { CalendarModal, CalendarModalOptions } from "ion2-calendar";
import * as moment from "moment";
import { MedicamentosService } from "src/services/medicamentos.service";
import { PacientService } from "src/services/pacient.service";

@Component({
  selector: "time-line-medicamento-component",
  templateUrl: "time-line-medicamento-component.html",
  styleUrls: ["./time-line-medicamento-component.scss"],
})
export class TimeLineMedicamentoComponent implements OnInit {
  emptyStateMedicamentos = {
    imgUrl: "/assets/imgs/bg-medicamentos.svg",
    title: "O paciente não tem nenhum medicamento recebido.",
    text: "No momento, não há registro de dispensação de medicamentos vinculados ao paciente.",
  };
  emptyStateMedicamentosFiltered = {
    imgUrl: "/assets/imgs/bg-medicamentos.svg",
    title: "O paciente não tem nenhum medicamento recebido.",
    text: "No momento, não há registro de dispensação de medicamentos vinculados ao paciente.",
  };

  next: any;
  userFiltro: any;

  medicamentosList: any = [];
  conteudoRevelado: boolean = false;
  filtrosSelecionados: any[] = [];
  listaFiltroMedicamento: any[] = [];
  listaFiltroMunicipios: any[] = [];
  dtFim: any;
  dtInicio: any;

  @Output() medClicked = new EventEmitter();

  constructor(
    private pacient: PacientService,
    private medicamentoSv: MedicamentosService,
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private loadingCtrl: LoadingController
  ) { }

  async ngOnInit() {
    await this.loadData();

    this.medicamentosList.forEach((med) => {
      if (!this.listaFiltroMedicamento.includes(med.nomeMedicamento)) {
        this.listaFiltroMedicamento.push(med.nomeMedicamento);
      }

      if (
        !this.listaFiltroMunicipios.includes(
          `${med.municipio} / ${med.ufRetirada}`
        )
      ) {
        this.listaFiltroMunicipios.push(`${med.municipio} / ${med.ufRetirada}`);
      }
    });
  }

  async detalhar(med) {
    this.medClicked.emit(med);
  }

  async formatData(data) { }

  async formatHora(data) { }

  async loadData() {
    let loading = await this.loadingCtrl.create({});
    await loading.present();

    this.userFiltro = await this.pacient.getInfo();

    try {
      const history: any = await this.pacient.recuperarMedicamentosRecebidos(
        0,
        0,
        0,
        1000,
        1
      );
      this.medicamentosList = history;
      await loading.dismiss();
    } catch (e) {
      console.error("error", e);
      await loading.dismiss();
    }
  }

  revelarConteudo() {
    this.conteudoRevelado = true;
  }

  filter(datas) {
    this.dtInicio = datas.dtInicio;
    this.dtFim = datas.dtFim;
  }

  get medicamentosListFiltered() {
    return this.medicamentosList.map((med) => ({
      tipo: "MEDICAMENTOS",
      nome: "Medicamentos recebidos",
      dtAtualizacao: med.dataRetirada,
      estabelecimento: med.nomeUnidadeDispensacao,
      nomeMedicamento: med.nomeMedicamento,
      coDispersao: med.coDispensacao,
      dtDispersao: med.dataRetirada,
      uf: med.ufRetirada,
      municipio: med.municipio,
      tipoDispersao: med.tpDispensacao,
      quantidade: med.qtdDispensada,
      vlTotal: med.vlTotal,
      vlCidada: med.vlCidadao,
      vlMinstSaude: med.vlMinstSaude,
    })).filter(
      (atendimento) => {
        let retorno = true;
        this.revelarConteudo();

        if (this.dtInicio && this.dtFim) {
          const dtAtendimento = moment(
            atendimento.dtAtualizacao,
            "DD/MM/YYYY hh:mm:ss"
          );
          console.log(dtAtendimento);
          const dtInicio = moment(this.dtInicio, "DD/MM/YYYY").subtract(1, "d");
          const dtFim = moment(this.dtFim, "DD/MM/YYYY").add(1, "d");

          if (!dtAtendimento.isBetween(dtInicio, dtFim)) {
            retorno = false;
          }

        }
        if (this.filtrosSelecionados.length) {
          let count = 0;
          const medFiltrosSelecionados = this.filtrosSelecionados
            .filter((filter) => filter.tipo === "medicamento")
            .map((filter) => filter.data);
          const ufFiltrosSelecionados = this.filtrosSelecionados
            .filter((filter) => filter.tipo === "municipio_uf")
            .map((filter) => filter.data.split(" / ")[1]);
          const municipiosFiltrosSelecionados = this.filtrosSelecionados
            .filter((filter) => filter.tipo === "municipio_uf")
            .map((filter) => filter.data.split(" / ")[0]);

          if (medFiltrosSelecionados.length) {
            if (!medFiltrosSelecionados.includes(atendimento.nomeMedicamento)) {
              count += 1;
            }
          }

          if (
            ufFiltrosSelecionados.length ||
            municipiosFiltrosSelecionados.length
          ) {
            if (
              ufFiltrosSelecionados.includes(atendimento.uf) &&
              municipiosFiltrosSelecionados.includes(atendimento.municipio)
            ) {
              count += 1;
            }
          }
          if (!!count) {
            retorno = false;
          }
        }
        return retorno;
      }
    ).sort((a, b) => {
      let oldDateFormatA = moment(a.dtAtualizacao,
        "DD/MM/YYYY hh:mm:ss")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let oldDateFormatB = moment(b.dtAtualizacao,
        "DD/MM/YYYY hh:mm:ss")
        .local()
        .format("MM-DD-YYYY HH:mm");
      let newDateA = new Date(oldDateFormatA);
      let newDateB = new Date(oldDateFormatB);

      return Number(newDateB.getTime()) - Number(newDateA.getTime());
    });
  }

  addFilter(data, tipo) {
    if (!data) {
      return;
    }
    this.revelarConteudo();

    const filtro = {
      tipo,
      data,
    };

    if (!this.filtrosSelecionados.includes(filtro)) {
      this.filtrosSelecionados.push(filtro);
    }
  }

  async openCalendar(field) {
    if (!this.dtInicio || !this.dtFim) {
      const options: CalendarModalOptions = {
        id: field,
        pickMode: "single",
        title: "Selecione as datas desejadas",
        doneLabel: "",
        closeLabel: "",
        autoDone: true,
        canBackwardsSelected: true,
        step: 12,
        weekdays: ["D", "S", "T", "Q", "Q", "S", "S"],
        weekStart: 0,
      };

      const modal = await this.modalCtrl.create({
        component: CalendarModal,
        keyboardClose: true,
        cssClass: "modal-calendar",
        componentProps: { options },
      });

      modal.onDidDismiss().then((event) => {
        this[field] = moment(event.data.string, "YYYY-MM-DD").format(
          "DD/MM/YYYY"
        );
        return;
      });
      return modal.present();
    } else if (this[field]) {
      this[field] = null;
      return;
    }
  }

  async limparFiltro(field, filtro?) {
    if (field === "dtFim" || field === "dtInicio") {
      this[field] = null;
    }

    if (field === "box-filter") {
      this.filtrosSelecionados = filtro;
    }
  }
}
